/** Content from SureSpace_MASTER_Terms_9_5.pdf */

export const TERMS_AND_CONDITIONS_TITLE = 'SureSpace Terms & Conditions';

export const TERMS_AND_CONDITIONS_SECTIONS = [
  {
    title: '1. Introduction and Acceptance',
    body: [
      'These Terms constitute a legally binding agreement between you and SureSpace Technology FZE.',
      'By using the Platform, you agree to these Terms.',
    ],
  },
  {
    title: '2. Definitions',
    body: 'Platform means the SureSpace application. User means any individual using the Platform. Content means user-generated material. Events are experiences organized by SureSpace. Wingman refers to AI-assisted features.',
  },
  {
    title: '3. Nature of Services',
    body: 'SureSpace is a social networking platform and not a dating service. No guarantees of outcomes are provided.',
  },
  {
    title: '4. Eligibility',
    body: 'Users must be 18+ and capable of entering legal agreements.',
  },
  {
    title: '5. User Accounts',
    body: 'Users must provide accurate information and maintain account security. SureSpace may remove harmful or misleading accounts.',
  },
  {
    title: '6. User Conduct',
    body: 'Users must not engage in abuse, harassment, or unlawful behavior.',
  },
  {
    title: '7. User Content',
    body: 'Users retain ownership but grant SureSpace a license to operate the platform.',
  },
  {
    title: '8. Wingman System and AI-Assisted Features',
    body: [
      'Wingman is an AI-assisted feature and does not constitute advice. Users remain solely responsible for their actions and decisions. SureSpace does not guarantee compatibility or outcomes.',
      'AI-generated suggestions may be imperfect. Further information on data processing is set out in the Privacy Policy.',
    ],
  },
  {
    title: '9. Events and In-Person Interactions',
    body: "Participation in events is voluntary and at the user's own risk. Users assume all risks associated with interactions. SureSpace is not responsible for user conduct, third-party venues, or any injuries, damages, or disputes arising.",
  },
  {
    title: '10. Indemnity',
    body: 'Users agree to indemnify SureSpace against claims arising from use of the Platform.',
  },
  {
    title: '11. Payments',
    body: 'Pricing is displayed in-app. Refunds may be requested within 7 days.',
  },
  {
    title: '12. Limitation of Liability',
    body: 'SureSpace shall not be liable for indirect or consequential damages, including loss of data, personal injury, or damages from user interactions. Liability is limited to fees paid in the preceding 12 months.',
  },
  {
    title: '13. Termination, Inactivity, and Dormant Accounts',
    body: 'Accounts may be terminated at discretion. Accounts inactive for 30 days may be classified as dormant. Users may be notified and accounts may be deleted after a further 30 days. Associated data may be permanently removed.',
  },
  {
    title: '14. Governing Law',
    body: 'These Terms are governed by UAE law with jurisdiction in Sharjah.',
  },
];
